export const numberWithSpace = (x, space = ' ') =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, space)
